import Base from './Base';

export default class ImageModel extends Base  {
	public id: number;
	public image: string;
	public imageUrl: string;
	public file: File;
	public remove: number;
	constructor(img?: string) {
		super(null);

		this.id 		= 0;
		this.image 		= "";
		this.imageUrl	= "";
		this.remove 	= 0;
		if(img) {
			this.image = img;
			this.imageUrl = img;
		}
	}

	newImage(file: any) {
		this.file = file;
		if(this.imageUrl != "") {
			this.remove = 1;
		}
	}

	removeImage() {
		if(this.file) {
			this.file = null;
			this.remove = 0;
		} else if(this.imageUrl != ""){
			this.remove = 1;
		}
	}

	getImage() {
		let retImage = "";
			if(this.file) {
				retImage = URL.createObjectURL(this.file);	
			} else if(this.remove == 0 && this.imageUrl != "") {
				retImage = this.imageUrl;
			}
		return retImage;
	}		
}